import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import CustomInput from '../CustomInput';
import { Calendar, Vector } from '../Svg/Svg';
import moment from 'moment';
import 'moment-timezone';
import CustomDatepicker from '../CustomDatepicker/CustomDatepicker';
import CustomSelect from '../CustomSelect/CustomSelect';

const stylesSelect = {
    option: (provider, state) => ({
        ...provider,
        backgroundColor: state.isFocused ? '#e5e6ff' : 'transparent',
        color: 'hsl(0, 0%, 20%)',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: 'e5e6ff',
        },
        ':active': {
            backgroundColor: 'e5e6ff',
        },
    }),
};

export function TableTopPannel({
    title,
    onAddButtonClick,
    buttonText,
    onInputChange,
    inputValue,
    withFilter,
    datepicker,
    select,
    searchInputPlaceholder,
    onHandleSortByChange,
    options,
    selectedOption,
    withSortBy,
    isLoading,
    errors,
    additionalButtons,
}) {
    const [isShown, setIsShown] = useState(false);
    const [savedStartDate, setSavedStartDate] = useState(false);
    const [savedEndDate, setSavedEndDate] = useState(false);
    const [date, setDate] = useState(
        `${moment
            .tz(datepicker?.from_date, 'UTC')
            .format('DD MMM yyyy')} - ${moment
            .tz(datepicker?.to_date, 'UTC')
            .format('DD MMM yyyy')}`,
    );
    const [data, setData] = useState({
        selected_id: select?.selected_id,
        startDate: moment.tz(datepicker?.from_date, 'UTC').format('YYYY-MM-DD'),
        endDate: moment.tz(datepicker?.to_date, 'UTC').format('YYYY-MM-DD'),
    });

    const [isSelect, setIsSelect] = useState(false);
    const [isDatepicker, setIsDatepicker] = useState(false);
    const [selectOptions, setSelectOptions] = useState([]);

    useEffect(() => {
        const selectOptions = select?.data?.reduce((acc, el) => {
            acc.push({
                id: el.id,
                value: el.name.toUpperCase(),
                label: el.name,
            });

            return acc;
        }, []);
        setSelectOptions(selectOptions);

        setSavedStartDate(moment.tz(datepicker?.from_date, 'UTC').toDate());
        setSavedEndDate(moment.tz(datepicker?.to_date, 'UTC').toDate());
        setDate(
            `${moment
                .tz(datepicker?.from_date, 'UTC')
                .format('DD MMM yyyy')} - ${moment
                .tz(datepicker?.to_date, 'UTC')
                .format('DD MMM yyyy')}`,
        );

        setData({
            selected_id: select?.selected_id,
            startDate: moment
                .tz(datepicker?.from_date, 'UTC')
                .format('YYYY-MM-DD'),
            endDate: moment.tz(datepicker?.to_date, 'UTC').format('YYYY-MM-DD'),
        });
        if (selectOptions?.length && select?.selected_id && !isLoading) {
            setIsSelect(true);
        } else if (isLoading) {
            setIsSelect(false);
        }
        if (datepicker?.from_date && datepicker?.to_date && !isLoading) {
            setIsDatepicker(true);
        } else if (isLoading) {
            setIsDatepicker(false);
        }
    }, [select, datepicker, isLoading]);

    const getDate = (dateStr, dateObj) => {
        setSavedStartDate(dateObj.start);
        setSavedEndDate(dateObj.end);
        setDate(dateStr);
        setData({
            ...data,
            startDate: moment(dateObj.start).format('YYYY-MM-DD'),
            endDate: moment(dateObj.end).format('YYYY-MM-DD'),
        });
    };

    const onSelectChange = (option) => {
        setData({ ...data, selected_id: option.id });
    };

    return (
        <div className="table-top-pannel">
            <div className="table-top-pannel__info">
                <h2 className="table-top-pannel__title">{title}</h2>
                {withFilter && (
                    <CustomInput
                        id="filter"
                        searchIcon
                        placeholder={searchInputPlaceholder}
                        onInputChange={onInputChange}
                        inputValue={inputValue}
                    />
                )}
                {isDatepicker && (
                    <div className="table-top-pannel__item">
                        <div
                            className="datepicker__date-frame"
                            onClick={() => setIsShown(!isShown)}
                        >
                            <Calendar />
                            <span className="datepicker__date-frame-text">
                                {date}
                            </span>
                            <span
                                className={`${
                                    isShown
                                        ? 'datepicker__date-frame--isOpen'
                                        : ''
                                }`}
                            >
                                <Vector />
                            </span>
                        </div>
                        {isShown && (
                            <CustomDatepicker
                                disabledTime
                                getDate={getDate}
                                setIsShown={() => setIsShown(false)}
                                savedStartDate={savedStartDate}
                                savedEndDate={savedEndDate}
                                errors={errors}
                            />
                        )}
                    </div>
                )}
                {isSelect && (
                    <div className="table-top-pannel__item">
                        <CustomSelect
                            name={select.name}
                            onChange={onSelectChange}
                            options={selectOptions}
                            placeholder={`Select ${select.name}`}
                            value={data.selected_id}
                        />
                    </div>
                )}
            </div>
            {withSortBy && (
                <CustomSelect
                    name="sortBy"
                    onChange={onHandleSortByChange}
                    options={options || []}
                    placeholder="Sort by..."
                    value={selectedOption.id}
                    isSearchable={false}
                    customStyles={stylesSelect}
                />
            )}

            {additionalButtons ? additionalButtons : null}

            <Button
                className={`table-top-pannel__button ${
                    withSortBy ? 'table-top-pannel__button--ml' : ''
                }`}
                type="primary"
                size="large"
                onClick={() => onAddButtonClick(data)}
            >
                {buttonText}
            </Button>
        </div>
    );
}
